import { ensureOrderDraftV02 } from './createOrderDraft';
import type { OrderDraft } from '../types/orderDraft';

const orderKeyPrefix = 'calendar_studio.order.';
const lastOrderKey = 'calendar_studio.last_order_id';

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function saveOrderDraft(draft: OrderDraft) {
  if (!canUseStorage()) return;
  window.localStorage.setItem(`${orderKeyPrefix}${draft.id}`, JSON.stringify(draft));
  window.localStorage.setItem(lastOrderKey, draft.id);
}

export function loadOrderDraft(orderId: string): OrderDraft | null {
  if (!canUseStorage()) return null;
  const rawDraft = window.localStorage.getItem(`${orderKeyPrefix}${orderId}`);
  if (!rawDraft) return null;

  try {
    return ensureOrderDraftV02(JSON.parse(rawDraft) as OrderDraft);
  } catch {
    return null;
  }
}

export function loadLastOrderDraft(): OrderDraft | null {
  if (!canUseStorage()) return null;
  const lastOrderId = window.localStorage.getItem(lastOrderKey);
  return lastOrderId ? loadOrderDraft(lastOrderId) : null;
}

export function listOrderDrafts(): OrderDraft[] {
  if (!canUseStorage()) return [];
  const drafts: OrderDraft[] = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (!key?.startsWith(orderKeyPrefix)) continue;
    const draft = loadOrderDraft(key.slice(orderKeyPrefix.length));
    if (draft) drafts.push(draft);
  }
  return drafts.sort((first, second) => new Date(second.updatedAt).getTime() - new Date(first.updatedAt).getTime());
}

export function deleteOrderDraft(orderId: string) {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(`${orderKeyPrefix}${orderId}`);
  if (window.localStorage.getItem(lastOrderKey) === orderId) {
    window.localStorage.removeItem(lastOrderKey);
  }
}
